import { useState, useEffect } from 'react';

// Sabit kripto listesi
const STATIC_CRYPTO_LIST = [
  { value: "btc", label: "BTC" },
  { value: "doge", label: "DOGE" },
  { value: "eth", label: "ETH" },
  { value: "bnb", label: "BNB" },
  { value: "sol", label: "SOL" },
  { value: "xrp", label: "XRP" },
  { value: "ada", label: "ADA" },
  { value: "matic", label: "MATIC" },
  { value: "dot", label: "DOT" },
  { value: "avax", label: "AVAX" }
];

export const useCryptoData = () => {
  const [cryptoList, setCryptoList] = useState([]);
  const [fiatList, setFiatList] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCryptoAndFiat = async () => {
      try {
        // Sabit kripto listesini kullan
        setCryptoList(STATIC_CRYPTO_LIST);
        
        // Sabit fiat listesi
        const fiatOptions = [
          { value: "USDT", label: "Tether USD (USDT)" },
          { value: "EUR", label: "Euro (EUR)" },
          { value: "BTC", label: "Bitcoin (BTC)" },
          { value: "ETH", label: "Ethereum (ETH)" },
          { value: "GBP", label: "British Pound (GBP)" },
          { value: "AUD", label: "Australian Dollar (AUD)" },
          { value: "TRY", label: "Turkish Lira (TRY)" },
          { value: "BRL", label: "Brazilian Real (BRL)" },
          { value: "RUB", label: "Russian Ruble (RUB)" }
        ];
        
        setFiatList(fiatOptions);
      } catch (error) {
        console.error("Data fetch failed:", error);
        setError("Unable to load data. Please try again later.");
      }
    };

    fetchCryptoAndFiat();
  }, []);

  return { cryptoList, fiatList, error };
}; 
